// Contraste APCA (Lc), o método do rascunho do WCAG 3 (W3C), na versão
// 0.0.98G-4g do apca-w3: https://github.com/Myndex/apca-w3. Diferente da
// razão do WCAG 2, ele mede o contraste como a gente percebe e não favorece o
// preto em cor média -- no #20a649 o WCAG 2 dava preto, o APCA dá branco.
const luminanciaApca = (hex) => {
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255);
  const y = 0.2126729 * r ** 2.4 + 0.7151522 * g ** 2.4 + 0.072175 * b ** 2.4;
  return y > 0.022 ? y : y + (0.022 - y) ** 1.414;
};

const contrasteApca = (texto, fundo) => {
  const t = luminanciaApca(texto);
  const f = luminanciaApca(fundo);
  if (Math.abs(f - t) < 0.0005) return 0;
  // Texto escuro em fundo claro, e o contrário: cada polaridade tem expoentes próprios.
  const s = f > t ? (f ** 0.56 - t ** 0.57) * 1.14 : (f ** 0.65 - t ** 0.62) * 1.14;
  return Math.abs(s) < 0.1 ? 0 : (Math.abs(s) - 0.027) * 100;
};

// Cor clara pede texto escuro: vence a cor de texto com mais contraste APCA.
// Aceita "#abc", "#aabbcc" e o "rgb(r, g, b)" do getComputedStyle.
export const ehClara = (cor) => {
  let hex;
  const rgb = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(cor);
  if (rgb) {
    hex = rgb.slice(1, 4).map((n) => Number(n).toString(16).padStart(2, '0')).join('');
  } else {
    hex = cor.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map((c) => c + c).join('');
  }
  return contrasteApca('000000', hex) > contrasteApca('ffffff', hex);
};

// A cor que está de fato atrás de um elemento: sobe pelos pais até achar um
// fundo que não seja transparente. Sem nenhum, é o branco da página.
export const corDoFundo = (el) => {
  for (let no = el?.parentElement; no; no = no.parentElement) {
    const cor = getComputedStyle(no).backgroundColor;
    const alfa = /^rgba\(.*,\s*([\d.]+)\)$/.exec(cor);
    if (cor && cor !== 'transparent' && !(alfa && Number(alfa[1]) === 0)) return cor;
  }
  return 'rgb(255, 255, 255)';
};
